export const CIRCLE_MOVE_TO_72 = { x: 36, y: 0.5 }

/** Bézier control points span ~0.5–71.5; map to full [0,w]×[0,h] like square/triangle. */
const CIRCLE_PATH_EXTENT = 71
const CIRCLE_PATH_CENTER = 36

/** Cubic segment: control1, control2, end point (SVG C command). */
type CircleCubicSegment = {
  cx1: number
  cy1: number
  cx2: number
  cy2: number
  x: number
  y: number
}

export const CIRCLE_CUBIC_SEGMENTS_72: CircleCubicSegment[] = [
  { cx1: 55.6079, cy1: 0.5, cx2: 71.5, cy2: 16.3921, x: 71.5, y: 36 },
  { cx1: 71.5, cy1: 55.6079, cx2: 55.6079, cy2: 71.5, x: 36, y: 71.5 },
  { cx1: 16.3921, cy1: 71.5, cx2: 0.5, cy2: 55.6079, x: 0.5, y: 36 },
  { cx1: 0.5, cy1: 16.3921, cx2: 16.3921, cy2: 0.5, x: 36, y: 0.5 },
]

function normalizePoint(
  p: { x: number; y: number },
  width: number,
  height: number
): { x: number; y: number } {
  const sx = width / CIRCLE_PATH_EXTENT
  const sy = height / CIRCLE_PATH_EXTENT

  return {
    x: width / 2 + (p.x - CIRCLE_PATH_CENTER) * sx,
    y: height / 2 + (p.y - CIRCLE_PATH_CENTER) * sy,
  }
}

/**
 * Returns the SVG path string for the circle with cubic curves (M + C + Z),
 * normalized to the given width and height.
 */
export function getCirclePathString(width: number, height: number): string {
  const m = normalizePoint(CIRCLE_MOVE_TO_72, width, height)
  const parts: string[] = [`M ${m.x} ${m.y}`]

  for (const seg of CIRCLE_CUBIC_SEGMENTS_72) {
    const c1 = normalizePoint({ x: seg.cx1, y: seg.cy1 }, width, height)
    const c2 = normalizePoint({ x: seg.cx2, y: seg.cy2 }, width, height)
    const end = normalizePoint({ x: seg.x, y: seg.y }, width, height)

    parts.push(`C ${c1.x} ${c1.y} ${c2.x} ${c2.y} ${end.x} ${end.y}`)
  }

  parts.push('Z')
  return parts.join(' ')
}
